import { render, staticRenderFns } from "./change_account.vue?vue&type=template&id=7bb1d804&scoped=true&"
import script from "./change_account.vue?vue&type=script&lang=js&"
export * from "./change_account.vue?vue&type=script&lang=js&"
import style0 from "./change_account.vue?vue&type=style&index=0&id=7bb1d804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1d804",
  null
  
)

export default component.exports